import * as _ from "lodash";
import {IComponentOptions, ILogService, IScope, IWindowService} from "angular";
import {ApplicationService} from "../application/application.service";
import {User} from "../model/User";
import {PriorCourse} from "../model/PriorCourse";
import {IModalInstanceService} from "angular-ui-bootstrap";

class PriorStudyController {
    public modalInstance: IModalInstanceService;
    public resolve: any;
    public priorStudy: PriorCourse;
    public displayErrorState: boolean;
    public editDisabled: boolean;
    public currentUser: User;
    public dismiss: any;
    public form: ng.IFormController;
    public dt = new Date();
    public close: any;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $scope: IScope,
                private $window: IWindowService,
                private toaster,
                private applicationService: ApplicationService) {

        this.displayErrorState = true;
    }

    public $onInit() {
        this.$log.debug("PriorStudyController initialise");
        this.priorStudy = this.resolve.priorStudy;
        if(this.priorStudy === undefined || this.priorStudy === null) {
            this.priorStudy = new PriorCourse();
        }

    }

    public addPriorStudy() {
        if (this.form.$valid) {

            this.close({$value: this.priorStudy});
        } else {
            this.setDirty(this.form.$$controls);
        }
    }

    public setDirty(controls) {
        _.forEach(controls, (control) => {
            if (control.$setTouched !== undefined) {
                control.$setTouched();
            }

            if (control.$setDirty !== undefined) {
                control.$setDirty();
            }

            if (control.$$controls !== undefined) {
                this.setDirty(control.$$controls);
            }
        });
    }

    private cancel() {
        this.dismiss({$value: "cancel"});
    }


}

export const PriorStudyComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        editDisabled: "=",
        currentUser: "<",
        close: "&",
        dismiss: "&",
        resolve: "<"
    },
    controller: PriorStudyController,
    template: require("./prior-study.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/prior-study/prior-study.component.ts